import { useQuery } from '@tanstack/react-query'
import { fetchLastPriceForMints } from 'utils/tokens'
import { milliseconds } from 'date-fns'

export function useLatestBuyTokenPrice(tokenMint?: string) {
  return useLatestTokenPrice('buy-swap-token-price', tokenMint)
}

export function useLatestSellTokenPrice(tokenMint?: string) {
  return useLatestTokenPrice('sell-swap-token-price', tokenMint)
}

function useLatestTokenPrice(cacheKey: string, tokenMint?: string) {
  const { data: lastPrice } = useQuery({
    queryKey: [cacheKey, tokenMint],
    queryFn: async () =>
      (await fetchLastPriceForMints([tokenMint as string]))?.[0] ?? null,
    staleTime: milliseconds({ minutes: 30 }),
    cacheTime: milliseconds({ minutes: 30 }),
    retry: 3,
    enabled: !!tokenMint,
    refetchOnWindowFocus: false,
  })

  return { lastPrice }
}
